var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('default-widget-field',_vm._g(_vm._b({},'default-widget-field',_vm.googleDocsFieldProps,false),_vm.defaultFieldListeners)),_c('iframe',{staticStyle:{"width":"100%","min-height":"600px"},attrs:{"src":_vm.docsLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }